<template>
  <div class="flex-wrap flex-line container align-stretch">
    <div style="width:200px;min-width:200px;border-right:1px solid var(--border);">
      <BaseMenu :menus="menus" :actived="actived" @on-click="handleOpen"></BaseMenu>
    </div>
    <div style="flex-grow:1;padding:0 5px;">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  routerOption: {
    as_frame: true,
    as_default: true,
    redirect: 'day',
  },
  computed: {
    menus() {
      return [{
        name: '节假日管理',
        key: 'organization',
        icon: 'organization',
      }, {
        name: '假期管理',
        key: 'list',
        icon: 'contact',
      }, {
        name: '请假统计',
        key: 'entrance',
      }];
    },
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },
  },
  methods: {
    handleOpen(e) {
      this.RouteTo(e);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
